import React from 'react';
import { CollectionPropertyValue } from '../RealtimeCollectionProvider';
import { Checkbox } from '../editor/plugins/CheckListItem'; // Updated import path

function CollectionPropertyCheckboxSelect({
    property,
    onChangeValue,
    disabled = false,
}: {
    property: CollectionPropertyValue;
    onChangeValue: (value: string | undefined) => void;
    disabled?: boolean;
}) {
    const isChecked = property.value === 'true';

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        // Added event type
        onChangeValue(event.target.checked ? 'true' : 'false');
    };

    return (
        <div className="ml-1 flex items-center">
            <Checkbox checked={isChecked} onChange={handleChange} disabled={disabled} />
        </div>
    );
}

export default CollectionPropertyCheckboxSelect;
